"use client"
import { useAuthStore } from "@/app/store/authstore";
import { useToastStore } from "@/app/store/localapi";
import React, { useEffect, useRef } from "react";

interface PaypalSubscribeButtonProps {
  planId: string;
  amount: string;
  discount: string;
  planType: string;
}

const PaypalSubscribeButton: React.FC<PaypalSubscribeButtonProps> = ({
  planId,
  amount,
  discount,
  planType
}) => {
  const paypalRef = useRef<HTMLDivElement>(null);
  const clientId = "AXBDCUBzntulN6mvWbok7bymP6b6C9RDcfuFDq4id6YJ-uMQT4sI1oQ4oLndLzqD5PM_BEK9zlTa7vZ3"
  const user = useAuthStore((state) => state.user);
  const { login } = useAuthStore();
  const { showToast } = useToastStore()


  useEffect(() => {
    // Remove any previous script
    const existingScript = document.getElementById("paypal-sdk");
    if (existingScript) existingScript.remove();

    // Load PayPal SDK
    const script = document.createElement("script");
    script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&vault=true&intent=subscription`;
    script.id = "paypal-sdk";
    script.async = true;
    script.onload = () => {
      //@ts-expect-error its important to
      if (window.paypal && paypalRef.current) {
        //@ts-expect-error its important to
        window.paypal.Buttons({
          style: { shape: 'pill', color: 'blue', layout: 'vertical', label: 'subscribe' },
          createSubscription: function (
            data: Record<string, unknown>,
            actions: {
              subscription: {
                create: (options: { plan_id: string; value?: string }) => Promise<string>;
              };
            }
          ) {
            return actions.subscription.create({
              plan_id: planId,
              ...(amount && { value: amount }),
            });
          },
          onApprove: function (
            data: {
              subscriptionID: string;
              orderID?: string;
              [key: string]: unknown;
            }
          ) {
            const obj = {
              order_id: data.orderID,
              subscription_id: data.subscriptionID,
              plan_id: planId,
              plan_pid: planId,
              event_type: data.event_type || "INITIAL",
              res_id: "",
              resource_id: "",
              state: "intial",
              create_time: null,
              update_time: null,
              clearing_time: null,
              parent_payment: "",
              amount: (discount!=="0" ? parseFloat(discount) : parseFloat(amount)) * 1000000,
              currency: "USD",
              status: 1,
              plan_type: planType || "",
              type: "",
              user_id: user?.user_id,
              user_email: user?.user_email,
              user_name: user?.user_name,
            };
            try {
              fetch('https://payment.dramaflicksapp.com/api/v1/createsubscription', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(obj),
              })
                .then(response => response.json())
                .then(res => {
                  // console.log('payment_success:', res);
                  if (res.data?.Data?.premium_data) {
                    login({ ...user, ...res.data?.Data?.premium_data });
                    showToast('Payment Success', 'success');
                  }
                });
            } catch (error) {
              console.error('Error during payment processing:', error);
              showToast('An error occurred during payment processing. Please contact support.', 'error');
            }
          },
          onError: function (err: unknown) {
            console.error("PayPal error:", err);
            showToast("Payment failed. Please try again.", 'error');
          },
          onabort: function (data: unknown) {
            console.error("PayPal abort:", data);
            showToast("Payment was aborted.", 'error');
          },
          onCancel: function (data: unknown) {
            console.error("PayPal cancel:", data);
            showToast("Payment was canceled.", 'error');
          },
          
        }).render(paypalRef.current);
      }
    };
    document.body.appendChild(script);

    // Capture the current value of paypalRef
    const paypalDiv = paypalRef.current;

    // Cleanup
    return () => {
      if (paypalDiv) paypalDiv.innerHTML = "";
      const script = document.getElementById("paypal-sdk");
      if (script) script.remove();
    };
  }, [planId, amount, login, showToast, user, discount, planType, user?.user_id, user?.user_email, user?.user_name]);

  return <div ref={paypalRef} />;
};

export default PaypalSubscribeButton;

//  <PaypalSubscribeButton
//         planId="P-XXXXXXXXXXXX" // your PayPal plan ID
//         clientId="sb" // your PayPal client ID (use "sb" for sandbox)
//       />